import { useTranslation } from 'react-i18next'
import { cn } from 'ui/lib/utils'

import { getActiveSnoozeCount } from '~/boundedContext/cards/utils/card'
import { getSnoozeBadgeClassName } from '~/boundedContext/cards/utils/snooze-palette'
import type { Card } from '~/db/types'
import { useSettingsStore } from '~/stores/settings'

type SnoozeCountBadgeProps = {
  card: Pick<Card, 'snoozeCountSource' | 'snoozeCountLearn' | 'snoozedUntilSource' | 'snoozedUntilLearn'>
  className?: string
  compact?: boolean
}

export const SnoozeCountBadge = ({ card, className, compact }: SnoozeCountBadgeProps) => {
  const { t } = useTranslation()
  const cardsFront = useSettingsStore(state => state.cardsFront)
  const snoozeCount = getActiveSnoozeCount(card, cardsFront)
  if (!snoozeCount) return null

  const fullLabel = t('Snoozed {{count}} times', { count: snoozeCount })
  const label = compact ? `x${snoozeCount}` : fullLabel

  return (
    <span
      className={cn(
        'inline-flex min-w-0 max-w-full items-center justify-center truncate rounded-full px-2 py-0.5 text-xs font-medium tabular-nums',
        getSnoozeBadgeClassName(card, cardsFront),
        className,
      )}
      title={fullLabel}
    >
      {label}
    </span>
  )
}
